<template>
  <div class="common">
    <div class="page-btns-main">
      <div class="page-main no-shadow">
        <a-steps :current="current" class="common-step">
          <a-step
            v-for="item in steps"
            :key="item.title"
            :title="item.title"
          ></a-step>
        </a-steps>
      </div>

      <div>
        <keep-alive
          ><component
            ref="bankComp"
            :is="steps[current].comp"
            :params="steps[current].params"
            :text="steps[current].text"
          ></component
        ></keep-alive>
      </div>
    </div>
    <div class="spaceCenter page-bottom-btns">
      <a-button
        v-if="current == 0"
        style="margin-left: 8px"
        class="btn-big"
        @click="goback"
      >
        取消
      </a-button>
      <a-button
        v-if="current > 0 && current < steps.length - 1"
        style="margin-left: 8px"
        class="btn-big"
        @click="prev"
      >
        上一步
      </a-button>
      <a-button
        v-if="current < steps.length - 2"
        type="primary"
        class="btn-big"
        @click="next"
      >
        下一步
      </a-button>
      <buttonLoad
        v-if="current == steps.length - 2"
        type="primary"
        class="btn-big"
        @clickHandle="success"
        lable="确认"
      ></buttonLoad>
      <a-button
        v-if="current == steps.length - 1"
        class="btn-big"
        @click="goback"
      >
        返回
      </a-button>
    </div>
  </div>
</template>

<script>
import bankStepBase from "./bank-step-base";
import bankStepSupplement from "./bank-step-supplement";
import bankStepSuccess from "./bank-step-success";
import { bankBuildingApply } from "@/api/bank.js";
export default {
  name: "bankComp",
  components: {
    bankStepBase,
    bankStepSupplement,
    bankStepSuccess
  },
  data() {
    return {
      current: 0,
      steps: [
        {
          title: "基本信息",
          comp: "bankStepBase",
          params: null
        },
        {
          title: "补充资料",
          comp: "bankStepSupplement",
          params: null
        },
        {
          title: "已提交",
          comp: "bankStepSuccess",
          text: "平台审核通过后，将提交至银行！"
        }
      ]
    };
  },
  computed: {},
  methods: {
    next() {
      if (this.current == 0) {
        //提现申请
        this.$refs["bankComp"]
          .check()
          .then(res => {
            this.current++;
            this.steps[this.current].params = res;
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    prev() {
      this.current--;
    },
    success(btn) {
      this.$refs["bankComp"]
        .check()
        .then(resData => {
          bankBuildingApply(resData)
            .then(res => {
              this.current++;
              btn.closeLoad();
            })
            .catch(err => {
              console.log(err);
              btn.closeLoad();
            });
        })
        .catch(err => {
          console.log(err);
          btn.closeLoad();
        });
    },
    goback() {
      this.$router.push("/bank/bankList");
    }
  },
  created() {},
  watch: {}
};
</script>
<style scoped>
.common-step {
  width: 70%;
  margin: 18px auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/bank/bank-add.vue